export function dropdownNav() {
    const dropdownNavItem = document.querySelectorAll('.js-dropdownNav');

    dropdownNavItem.forEach( item => {
        let dropdownNavList = item.querySelector('.js-dropdownNavList');

        item.addEventListener('mouseenter', () => {
            item.classList.add('is-active');
            dropdownNavList.classList.add('is-active');
        });

        item.addEventListener('mouseleave', () => {
            item.classList.remove('is-active');
            dropdownNavList.classList.remove('is-active');
        });
    });
}
